import { useEffect, useState } from "react";
import { CustomDialog } from "../../../components/customDialog/CustomDialog"
import { RenderInputByTypeMobile } from "../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { Grid } from "@mui/material";
import moment from "moment";
import toast from "react-hot-toast";

export const EditPeriodoDialog = ({
    onCancel,
    onAccept,
    acceptLoading,
    open,
    periodo
}) => {
    const [periodoAux, setPeriodoAux] = useState(periodo);

    useEffect(() => {
        setPeriodoAux(periodo);
    }, [periodo]);

    const handleChange = (name, value) => {
        setPeriodoAux((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAccept = () => {
        if(moment(periodoAux.fechaHasta).isBefore(moment(periodoAux.fechaDesde))) {
            toast.error('La fecha hasta no puede ser anterior a la fecha desde');
            return;
        }
        onAccept(periodoAux);
    }

    return (
        <>
            <CustomDialog
                maxWidth='md'
                fullWidth
                onCancel={onCancel}
                onAccept={handleAccept}
                acceptLoading={acceptLoading}
                open={open}
                cancelText='Cancelar'
                acceptText='Guardar'
                title={'Editar Período'}>
                <Grid container spacing={2}>
                    {inputs.map((input) => (
                        <Grid size={{ xs: 12, md: 6 }} key={input.name}>
                            <RenderInputByTypeMobile
                                input={input}
                                handleChange={handleChange}
                                value={periodoAux?.[input.name]}
                            />
                        </Grid>
                    ))}
                </Grid>
            </CustomDialog>
        </>
    )
}

const inputs = [
    {
        displayName: 'Mes',
        name: 'mes',
        type: 'string',
        disabled: true,
        required: true

    },
    {
        displayName: 'Año',
        name: 'anio',
        type: 'int',
        disabled: true,
        required: true

    },
    {
        displayName: 'Fecha Desde',
        name: 'fechaDesde',
        type: 'date',
        disabled: true,
        required: true

    },
    {
        displayName: 'Fecha Hasta',
        name: 'fechaHasta',
        type: 'date',
        disabled: false,
        required: true

    },
];